import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { MatPaginatorModule } from '@angular/material/paginator';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { UiModule } from './ui/ui.module';

import { HttpClientModule } from '@angular/common/http';
import { IonicStorageModule, Storage } from '@ionic/storage';
import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';

import { AppConfig } from './providers/app.config';
import { TokenService } from './providers/token.service';
import { AuthService } from './providers/auth.service';
import { GenericService } from './providers/generic.service';
import { AjaxService } from './providers/ajax.service';
import { ChartService } from './providers/chart.service';
import { RegexService } from './providers/regex.service';
import { LogService } from './providers/log.service';
import { NetworkService } from './providers/network.service';
import { IonicService } from './providers/ionic.service';
import { DataService } from './providers/data.service';
import { GlobalErrorHandler } from './providers/global-error.handler';
import { GlobalService } from './providers/global.service';
import { ThemeService } from './providers/theme.service';

import { AnimationService, AnimatesDirective } from 'css-animator';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthGuard } from './providers/auth-guard';
import { FileService } from './providers/file.service';
import { ImageService } from './providers/image.service';

import { Network } from '@ionic-native/network/ngx';
import { File } from '@ionic-native/File/ngx';
import { FlatpickrModule } from 'angularx-flatpickr';
import 'flatpickr/dist/flatpickr.css';
import { TooltipsModule } from 'ionic-tooltips';
//import { CalenderPageModule } from './pages/modal/calender/calender.module';

import { ImagePageModule } from './pages/modal/image/image.module';
import { ProfilePopoverPageModule } from './pages/modal/profilepopover/profilepopover.module';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';





export function getJwtHttp(tokenService: TokenService) {
    return {
        tokenName: 'access_token',
        tokenGetter: (() => {
            return tokenService.getAccessToken();
        }),
        globalHeaders: [{ 'Content-Type': 'application/json' }]
    };
}

@NgModule({
    declarations: [AppComponent],
    entryComponents: [],
    imports: [
        MatDatepickerModule,
        MatInputModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        BrowserModule,
        TooltipsModule,
        BrowserAnimationsModule,
        FormsModule,
        CommonModule,
        MatPaginatorModule,
        IonicModule.forRoot(),
        IonicStorageModule.forRoot(),
        HttpClientModule,
        ImagePageModule,
        ProfilePopoverPageModule,
        JwtModule.forRoot(
            {
                jwtOptionsProvider:
                {
                    provide: JWT_OPTIONS,
                    useFactory: getJwtHttp,
                    deps: [TokenService]
                }
            }),
        AppRoutingModule,
        UiModule,
        FlatpickrModule.forRoot(),
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
    ],
    providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        AppConfig,
        GenericService,
        AjaxService,
        AuthService,
        AuthGuard,
        TokenService,
        ChartService,
        RegexService,
        FileService,
        ImageService,
        LogService,
        NetworkService,
        IonicService,
        DataService,
        GlobalService,
        GlobalErrorHandler,
        ThemeService,
        AnimationService,
        AnimatesDirective,
        Network,
        File
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
